/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { DateFormatOptions } from "./DateFormatOptions";
import { defaultLocale, defaultTimezone } from "./constants";

/**
 * Converts given UTC date time to the local day using the provided options.
 * @example "01" (for the first day of a month using "en-US" locale).
 * @example "31" (for the 31st day of a month using "en-US" locale).
 * @param date The date-time to convert.
 * @param options The options for formatting the date.
 * @returns The formatted local day.
 */
export const toLocalDay = (date: Date, options: DateFormatOptions): string => {
    const { locale, timeZone } = options;

    return Intl.DateTimeFormat(locale ? locale : defaultLocale, {
        day: "2-digit",
        timeZone: timeZone ? timeZone : defaultTimezone
    }).format(date);
};
